import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, IconButton } from '@mui/material';

import { ReactComponent as CloseIcon } from '../../assetsNew/icons/cancel.svg';

import './_modal.scss';

const Modal = ({
                 children,
                 open,
                 closeModal = () => {},
                 disableClose = false,
                 disableRestoreFocus = false,
                 className
}) => (
  <Dialog classes={{ paperScrollPaper: 'scroll-paper' }} className={`custom-modal ${className || ''}`} onClose={closeModal} open={open} disableRestoreFocus={disableRestoreFocus}>
    <DialogContent className="modal-content">
      {!disableClose && <IconButton onClick={closeModal} edge="start" className="close" color="inherit"><CloseIcon /></IconButton>}
      {children}
    </DialogContent>
  </Dialog>
);

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  disableClose: PropTypes.bool,
  disableRestoreFocus: PropTypes.bool,
  className: PropTypes.string
};

export default Modal;
